import { Query } from '@datorama/akita';
import { UserInfo } from '@app/core/models';
import { Injectable } from '@angular/core';
import { UserInfoStore } from './user-info.store';


@Injectable({
	providedIn: 'root'
})
export class UserInfoQuery extends Query<UserInfo> {

	userInfo$ = this.select(state => state);

	constructor(protected store: UserInfoStore) {
		super(store);
	}
}
